export function formatCampaignDateRange(start: string, end: string) {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const sameYear = startDate.getFullYear() === endDate.getFullYear();

  const startOptions: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    ...(sameYear ? {} : { year: "numeric" }),
  };
  const endOptions: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };

  const startStr = startDate.toLocaleDateString("en-US", startOptions);
  const endStr = endDate.toLocaleDateString("en-US", endOptions);

  return `${startStr} - ${endStr}`;
}